export default __webpack_public_path__ + "static/media/spaghetti.59fcea17.jpg";